<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Chip, ListItem, Stack, Text } from '@Shelly/shelly-design-system';
	import type { DevicePhaseBar } from 'src/helpers/emeter_sidepanel_helpers';

	export let phases: DevicePhaseBar[] = [];
	export let imbalancePercent = 0;
	export let isBalanced = true;
	export let className = '';
	export { className as class };

	const phaseProgressColor = (tone: 'primary' | 'success' | 'warning') => {
		if (tone === 'warning') return 'warning';
		if (tone === 'success') return 'success';
		return 'heating';
	};
</script>

{#if phases.length}
	<div class="emeter-phase-bars mb-m {className}">
		<div class="emeter-phase-bars__summary mb-s">
			<Text styleType="miniature" class="text-color-muted">
				{$format('energy_monitoring_phase_health_title', { default: 'Phase health' })}
			</Text>
			<Chip
				variant={isBalanced ? 'success' : 'warning'}
				size="m"
				aria-label={isBalanced
					? $format('camera_nv_balanced', { default: 'Balanced' })
					: $format('energy_monitoring_phase_imbalanced', {
							default: 'Imbalanced {percent}%',
							values: { percent: imbalancePercent },
						})}
			>
				{isBalanced
					? $format('camera_nv_balanced', { default: 'Balanced' })
					: $format('energy_monitoring_phase_imbalanced', {
							default: 'Imbalanced {percent}%',
							values: { percent: imbalancePercent },
						})}
			</Chip>
		</div>

		<Stack gap="xs">
			{#each phases as phase (phase.phase)}
				<ListItem
					viewType="bar"
					title={phase.displayName ||
						$format('energy_monitoring_phase_label', {
							default: 'Phase {phase}',
							values: { phase: phase.phase },
						})}
					progress={{
						percent: phase.percent,
						title: phase.label,
						color: phaseProgressColor(phase.tone),
						showPercentBar: true,
					}}
					a11yProps={{ progressbarAriaLabel: phase.label }}
				/>
			{/each}
		</Stack>
	</div>
{/if}

<style>
	.emeter-phase-bars__summary {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--spacing-s);
	}
</style>
